export function StarMark({ className = "h-6 w-6" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <path d="M32 4 L37.5 26.5 L60 32 L37.5 37.5 L32 60 L26.5 37.5 L4 32 L26.5 26.5 Z" fill="#38bdf8" />
      <circle cx="49" cy="13" r="4" fill="#c084fc" />
    </svg>
  );
}

export function Logo({ className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <span className="relative flex items-center justify-center">
        <StarMark className="h-7 w-7" />
        <span className="absolute inset-0 h-7 w-7 rounded-full bg-cyan-400/30 blur-md animate-pulse-soft" />
      </span>
      <span className="font-display text-xl font-800 tracking-[0.28em] font-bold text-white">ASTRA</span>
    </div>
  );
}
